<template>
  <el-container class="page-x" direction="vertical">
    <div class="top-box">
      <div class="top-left">
        <div class="user-box">
          <div class="options">
            <div class="h3-title h3-title-icon yh">用户数据</div>
            <div class="h3-options">
              <template v-for="(item, i) in timeSelect">
                <span class="options-box" :key="item.value">
                  <span v-if="i !== 0" class="line">|</span>
                  <span
                    class="a"
                    :class="{
                      on: item.value === userTimeSelect,
                    }"
                    @click="changeTimeSelect('userTimeSelect', item.value)"
                    >{{ item.name }}</span
                  >
                </span>
              </template>
            </div>
          </div>
          <div class="user-data">
            <div class="id-chart">
              <!-- 用户数据-身份分部-饼图 -->
              <div id="userChart" style="width: 100%; height: 100%"></div>
              <div class="service-text">单位：人</div>
            </div>
            <div class="gender-chart">
              <!-- 用户数据-年龄性别分布-柱状图 -->
              <div
                id="genderChart"
                style="width: 100%; height: 100%; position: relative"
              ></div>
            </div>
          </div>
        </div>
        <div class="service-box mt16">
          <div class="options">
            <div class="h3-title h3-title-icon fw">服务数据</div>
          </div>
          <div class="service-numbers">
            <p>
              <span>累计使用次数</span
              ><strong>{{ serviceData.totalCount }}</strong>
            </p>
            <p>
              <span>服务覆盖率</span
              ><strong>{{ serviceData.serviceCoverage }}%</strong>
            </p>
            <p>
              <span>服务使用率</span
              ><strong>{{ serviceData.serviceUtilization }}%</strong>
            </p>
          </div>
          <div class="service-data">
            <div class="h3-options">
              <!-- <el-checkbox-group
                v-model="checkList"
                @change="changeTimeSelect('serviceTimeSelect', checkList)"
                style="margin-right: 20px; font-size: 12px; font-weight: normal"
              >
                <el-checkbox
                  label="客户"
                  style="margin-right: 10px"
                ></el-checkbox>
                <el-checkbox
                  label="准客户"
                  style="margin-right: 10px"
                ></el-checkbox>
                <el-checkbox
                  label="游客"
                  style="margin-right: 10px"
                ></el-checkbox>
              </el-checkbox-group> -->
              <template v-for="(item, i) in timeSelect">
                <span class="options-box" :key="item.value">
                  <span v-if="i !== 0" class="line">|</span>
                  <span
                    class="a"
                    :class="{
                      on: item.value === serviceTimeSelect,
                    }"
                    @click="changeTimeSelect('serviceTimeSelect', item.value)"
                    >{{ item.name }}</span
                  >
                </span>
              </template>
            </div>
            <div
              class="service-chart"
              :class="{
                'service-chart-empty': emptyServiceChart,
              }"
            >
              <!-- 服务数据-服务使用总粗疏-柱状图 -->
              <div
                class="serviceChart"
                id="serviceChart"
                style="width: 100%; height: 90%"
              ></div>
              <div class="tips" v-if="!emptyServiceChart">
                拖拽上方滑块选择统计时间范围
              </div>
              <div class="service-text">次数总计</div>
            </div>
            <div
              class="service-top5"
              :class="{
                'service-top5-empty': serviceTop.length === 0,
              }"
            >
              <h4 class="h4-title">服务top5</h4>
              <div class="service-text">次数总计</div>
              <ul class="top5-list">
                <li v-for="(item, i) in serviceTop" :key="i">
                  {{ item.productName }}
                  <div class="num">
                    {{ tripartite(item.counts) }}
                    <span
                      v-if="
                        item.serviceOrderCounts && item.serviceOrderCounts !== 0
                      "
                      >({{ item.serviceOrderCounts }})</span
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="top-right">
        <div class="white-box mb16">
          <div class="message-box">
            <h1>
              您好,{{ userInfo.loginName }}
              <span v-if="userInfo.roleNames">{{ userInfo.roleNames }}</span>
            </h1>
            <div class="co-name">{{ userInfo.org }}</div>
            <div class="login-time" v-if="userInfo.lastLoginTime">
              上次登录：{{ dateFormat(userInfo.lastLoginTime, "Y-m-d H:i:s") }}
            </div>
          </div>
        </div>
        <div class="white-box white-box-f1">
          <div
            class="'agency-box'"
            :class="{
              'agency-box-empty': messageList.length == 0,
            }"
          >
            <div class="h3-title">待办消息</div>
            <div class="msgWrap">
              <div
                class="msgItem"
                v-for="(item, i) in messageList"
                :key="i"
                @click="pushTo(item)"
              >
                <div class="msgTitle">
                  <a :title="item.title">{{ item.title }}</a>
                  <div @click.stop="pushIgnore(item)">忽略</div>
                </div>
                <div class="msgTime">
                  {{ dateFormat(item.updateTime, "Y-m-d") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="health-box mt16">
      <div class="options">
        <div class="h3-title h3-title-icon jk">健康数据</div>
        <div class="h3-options">
          <template v-for="(item, i) in timeSelect">
            <span class="options-box" :key="item.value">
              <span v-if="i !== 0" class="line">|</span>
              <span
                class="a"
                :class="{
                  on: item.value === healthyTimeSelect,
                }"
                @click="changeTimeSelect('healthyTimeSelect', item.value)"
                >{{ item.name }}</span
              >
            </span>
          </template>
        </div>
      </div>
      <div class="health-data">
        <div
          class="health-chart"
          :class="{
            'service-chart-empty': emptyServiceChart2,
          }"
        >
          <span class="service-text">人数总计</span>
          <div id="healthChart" style="width: 100%; height: 100%"></div>
        </div>
        <div class="health-line"></div>
        <div
          class="top5"
          :class="{
            'service-top5-empty': diseaseTop.length === 0,
          }"
        >
          <span class="service-text">人数总计</span>
          <h4 class="h4-title">疾病风险top5</h4>
          <ul class="top5-list">
            <li v-for="(item, i) in diseaseTop" :key="i">
              {{ item.diseaseName }}
              <div class="num">{{ tripartite(item.num) }}</div>
            </li>
          </ul>
        </div>
        <div class="health-line ml45"></div>
        <div
          class="top5"
          :class="{
            'service-top5-empty': riskTop.length === 0,
          }"
        >
          <span class="service-text">人数总计</span>
          <h4 class="h4-title">风险因素top5</h4>
          <ul class="top5-list">
            <li v-for="(item, i) in riskTop" :key="i">
              {{ item.riskFactorName }}
              <div class="num">{{ tripartite(item.num) }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="res-box mt16">
      <div class="options">
        <div class="h3-title h3-title-icon hb">核保数据</div>
      </div>
      <div class="res-data">
        <div class="res-user">
          <div class="service-text">单位：人</div>
          <!-- 核保数据-健康状态分布-柱状图 -->
          <div id="resChart" style="width: 100%; height: 100%"></div>
        </div>
        <div class="real-line"></div>
        <div class="res-user">
          <div class="service-text">单位：人</div>
          <!-- 核保数据-健康状态分布-柱状图2 -->
          <div id="realChart" style="width: 100%; height: 100%"></div>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import {
  createPie,
  createBar,
  createBarService,
  drawHealthChart,
  createPieAuto,
} from "./echarts";
import { dateFormat, tripartite } from "@/assets/js/until.js";
import _ from "loadsh";

export default {
  name: "Home",
  data() {
    return {
      checkList: [],
      userInfo: {}, // 用户信息，在登录时存储
      messageList: [], // 用户信息，在登录时存储

      // 时间选项表
      timeSelect: [
        {
          name: "全部",
          value: 6,
        },
        {
          name: "日",
          value: 1,
        },
        {
          name: "月",
          value: 2,
        },
        {
          name: "上半年",
          value: 3,
        },
        {
          name: "下半年",
          value: 4,
        },
        {
          name: "年",
          value: 5,
        },
      ],

      userTimeSelect: 6, // 用户数据年月日选择
      serviceTimeSelect: 6, // 服务数据年月日选择
      healthyTimeSelect: 6, // 健康数据年月日选择

      // 存储
      serviceData: {}, // 服务数据信息
      serviceTop: [], // 服务数据top5
      diseaseTop: [], // 疾病风险top5
      riskTop: [], // 风险因素top5

      emptyServiceChart: true, // 服务数据-柱状图是否为空
      emptyServiceChart2: false, // 健康数据-柱状图是否为空
    };
  },
  mounted() {
    if (localStorage.admin) {
      try {
        this.userInfo = JSON.parse(localStorage.admin);
      } catch (err) {}
    }
    this.getUser(); // 获取用户数据
    this.getService(); // 获取服务数据
    this.getHealthy(); // 获取健康数据
    this.getUnderwriting(); // 获取核保数据
    this.adminMessage(); // 获取待办消息
  },
  created() {
    // 面包导航
    this.$root.breadList = [];
  },
  methods: {
    tripartite,
    dateFormat,
    pushIgnore(item) {
      this.$confirm("忽略后将不再提示，请确认该事项已处理完成！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .get(this.getApiUrl("messageViewed"), {
              params: {
                id: item.id,
              },
            })
            .then((res) => {
              if (_.get(res, "code") == 1) {
                this.$message({
                  type: "success",
                  message: "忽略成功",
                });
                this.adminMessage();
              } else {
                this.$message({
                  type: "error",
                  message: res.code + res.msg,
                });
              }
            });
        })
        .catch(() => {});
    },
    async pushTo(item) {
      let id, providerAbbr;
      if (item.type == 2) {
        const res = await this.axios.get(
          this.getApiUrl("cmsproviderByServiceId"),
          {
            params: {
              serviceId: item.objId,
            },
          }
        );
        id = res.data.id;
        providerAbbr = res.data.providerAbbr;
      }

      switch (item.type) {
        case 1:
          this.$router.push({
            name: "SupplierManager",
            params: {
              id: item.objId,
            },
          });
          break;
        case 2:
          this.$router.push({
            name: "ServiceManager",
            query: {
              id,
              providerAbbr,
              tipid: item.objId,
            },
          });
          break;
        case 3:
          this.$router.push({
            name: "supplierEvaluate",
            params: {
              id: item.objId,
            },
          });
          break;
      }
    },
    // 获取用户数据
    async adminMessage() {
      // adminMessage
      const res = await this.axios.get(this.getApiUrl("adminMessage"), {
        params: {
          viewed: 0,
        },
      });
      this.messageList = _.get(res, "data.data", []);
    },
    async getUser() {
      // 获取数据
      const res = await this.axios.get(this.getApiUrl("cmsUserStatics"), {
        params: {
          staticsType: this.userTimeSelect,
        },
      });
      let userTypeCountList = [];
      let userTypeCountListName = ["客户", "准客户", "游客"];
      // 饼图
      if (res?.data?.userTypeCountList?.length) {
        userTypeCountListName.forEach((name) => {
          let data = res.data.userTypeCountList.find(
            (e) => e.name === name
          ) || {
            name,
            value: 0,
          };
          userTypeCountList.push(data);
        });
      } else {
        userTypeCountListName.forEach((item) => {
          userTypeCountList.push({
            name: item,
            value: 0,
          });
        });
      }
      // 用户数据-身份分部-饼图
      createPie(userTypeCountList);
      // 柱状图
      let cache = {
        femaleCount: [], // 女
        genderUnknownCount: [], // 未知
        maleCount: [], // 男
      };
      let ageGroupName = [];
      if (res?.data?.userAgeGroupList?.length) {
        res?.data?.userAgeGroupList.forEach((item) => {
          cache.femaleCount.push(item.femaleCount || 0);
          cache.genderUnknownCount.push(item.genderUnknownCount || 0);
          cache.maleCount.push(item.maleCount || 0);
          ageGroupName.push(item.ageGroupName || "");
        });
      }
      let ageAndGenderMap = new Map([
        ["男", cache.maleCount || []],
        ["女", cache.femaleCount || []],
        ["未知", cache.genderUnknownCount || []],
      ]);
      // 用户数据-年龄性别分布-柱状图
      createBar({
        series: ageAndGenderMap,
        ageGroupName,
      });
    },
    // 获取服务数据
    async getService() {
      const res = await this.axios.get(this.getApiUrl("cmsOrderStatics"), {
        params: {
          staticsType: this.serviceTimeSelect,
        },
      });
      // 服务数据信息
      this.serviceData = {
        totalCount: res?.data?.totalCount || 0,
        serviceCoverage: res?.data?.serviceCoverage || 0,
        serviceUtilization: res?.data?.serviceUtilization || 0,
      };
      // 服务top5
      this.serviceTop = res?.data?.productTop || [];
      // 柱状图数据处理
      let series = [];
      let x = [];
      if (res?.data?.orderTimeStatics) {
        Object.keys(res.data.orderTimeStatics).forEach((item) => {
          series.push(res.data.orderTimeStatics[item].counts);
          x.push(res.data.orderTimeStatics[item].timeStr);
        });
      }
      this.emptyServiceChart = !x.length;
      // 服务数据-服务使用总次数-柱状图
      createBarService({
        series,
        x,
      });
    },
    // 获取健康数据
    async getHealthy() {
      const res = await this.axios.get(this.getApiUrl("statisticsData"), {
        params: {
          statisticType: this.healthyTimeSelect, // 健康数据年月日选择
        },
      });
      // 疾病风险top5
      if (res?.data?.diseasesNumberRanking?.length) {
        this.diseaseTop = res?.data?.diseasesNumberRanking;
      } else {
        this.diseaseTop = [];
      }
      // 风险因素top5
      if (res?.data?.riskFactorRanking?.length) {
        this.riskTop = res?.data?.riskFactorRanking;
      } else {
        this.riskTop = [];
      }
      // 健康数据-健康状态分布-柱状图
      let x = ["极差", "很差", "较差", "一般", "较好", "很好", "极好"];

      let series = [];
      let cList = [
        "#A0523D",
        "#C36447",
        "#DB7957",
        "#F0A700",
        "#9ED500",
        "#40CF57",
        "#16D18D",
        // "#9B2800",
        // "#C53A09",
        // "#E85420",
        // "#F7B500",
        // "#E1E700",
        // "#A4D90F",
        // "#6DD400",
      ];
      if (res?.data?.hValueLevels?.length) {
        res.data.hValueLevels.forEach((item) => {
          let index = x.indexOf(item?.level);
          series[index] = {
            value: item.num,
            itemStyle: {
              color: cList[index],
            },
          };
        });
      }

      if (series.length === 0) {
        this.emptyServiceChart2 = true;
        x = [];
      } else {
        this.emptyServiceChart2 = false;
      }
      drawHealthChart({
        x,
        series,
      });
    },
    // 获取核保数据
    async getUnderwriting() {
      const res = await this.axios.get(
        this.getApiUrl("crmCustomerInsuredNUmber")
      );
      let data = {};
      if (res?.data?.rows && res?.data?.rows[0]) {
        data = res?.data?.rows[0];
      }
      // 核保数据-客户核保数据
      let customerData = [
        {
          name: "标体",
          value: Number(data.targetNumber) || 0,
        },
        {
          name: "非标体",
          value: Number(data.untargetNumber) || 0,
        },
      ];
      // 核保数据-有效客户核保数据
      let effectiveCustomerData = [
        {
          name: "标体",
          value: Number(data.effectTargetNumber) || 0,
        },
        {
          name: "非标体",
          value: Number(data.effectUntargetNumber) || 0,
        },
      ];

      // 核保数据-健康状态分布-柱状图
      createPieAuto("resChart", "客户核保数据", customerData);
      // 核保数据-健康状态分布-柱状图2
      createPieAuto("realChart", "有效客户核保数据", effectiveCustomerData);
    },
    // 修改时间
    changeTimeSelect(dataName, value) {
      this[dataName] = value;
      let api = {
        userTimeSelect: "getUser", // 获取用户数据
        serviceTimeSelect: "getService", // 获取服务数据
        healthyTimeSelect: "getHealthy", // 获取健康数据
      };
      if (api[dataName]) {
        this[api[dataName]]();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .check-box {
  margin-right: 10px;
}
.msgWrap {
  height: 400px;
  overflow-y: scroll;
}
.msgItem {
  &:hover {
    cursor: pointer;
    .msgTitle > div {
      display: block;
    }
  }
}

.msgTitle {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  display: flex;
  align-items: center;
  color: #333333;
  margin-top: 14px;
  justify-content: space-between;
  width: 95%;

  > a:nth-child(1) {
    align-items: center;
    display: block;
    position: relative;
    width: 240px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: 14px;
    text-decoration: none;
  }
  > div {
    color: #999;
    white-space: nowrap;
    display: none;
  }
  > a:nth-child(1)::before {
    content: "";
    width: 5px;
    height: 5px;
    background: #2051f5;
    border-radius: 2.5px;
    margin-right: 8px;
    position: absolute;
    top: 11px;
    left: 7px;
  }
}
.msgTime {
  margin-left: 14px;
  font-family: "DIN";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  display: flex;
  align-items: center;
  color: #999999;
}
.h3-title {
  flex: 1;
  font-weight: bold;
  font-size: 16px;
  line-height: 50px;
}
.h3-title.h3-title-icon {
  padding-left: 24px;
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 14px;
    width: 20px;
    height: 20px;
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
.yh::before {
  background-image: url(https://ins-pro-luban.miao.cn/online/source/image/dec1b730-0cb3-11ed-83ed-6fdc185632f2.png);
}
.fw::before {
  background-image: url(https://ins-pro-luban.miao.cn/online/source/image/d5d32fa0-0cb3-11ed-83ed-6fdc185632f2.png);
}
.hb::before {
  background-image: url(https://ins-pro-luban.miao.cn/online/source/image/e661c5c0-0cb3-11ed-83ed-6fdc185632f2.png);
}
.jk::before {
  background-image: url(https://ins-pro-luban.miao.cn/online/source/image/e2a4bdc0-0cb3-11ed-83ed-6fdc185632f2.png);
}

.service-text {
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: #666666;
}
.h3-options {
  font-size: 14px;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #999;
  vertical-align: bottom;
  .options-box {
    display: flex;
  }
  .line {
    cursor: default;
    display: inline-block;
    padding: 0 5px;
  }
  .on {
    color: #333;
    font-weight: 600;
  }
  .a {
    cursor: pointer;
  }
}
.options {
  display: flex;
  flex-direction: row;
}
.h4-title {
  margin: 10px 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: #666666;
}
.ml45 {
  margin-left: 45px;
}
.service-top5-empty {
  background-image: url(https://ins-pro-luban.miao.cn/online/source/image/c6d47990-07d7-11ed-83ed-6fdc185632f2.png);
  background-size: 240px 148px;
  background-position: center center;
  background-repeat: no-repeat;
}
.page-x {
  min-width: 1220px;
  padding-bottom: 40px;
  .mt16 {
    margin-bottom: 16px;
  }
  .top-box {
    display: flex;
    align-items: stretch;
    .top-left {
      flex: 1;
      min-width: 800px;
      .user-box {
        background: #ffffff;
        border-radius: 2px;
        padding: 7px 24px 24px;
        .user-data {
          display: flex;
          .id-chart {
            flex: 1;
            max-width: 420px;
            min-width: 420px;
            height: 210px;
            position: relative;
            .service-text {
              position: absolute;
              right: 20px;
              top: 4px;
            }
          }
          .id-numbers {
            flex: 1;
          }
          .gender-chart {
            flex: 2;
            height: 210px;
          }
          .gender-numbers {
            flex: 1;
          }
        }
      }
      .service-box {
        background: #ffffff;
        border-radius: 2px;
        padding: 7px 24px 24px;
        .service-numbers {
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          p {
            height: 64px;
            background: #e3e9ff;
            border-radius: 2px;
            flex: 1;
            margin-right: 10px;
            padding-top: 14px;
            span {
              font-size: 14px;
              color: #999;
              margin-left: 24px;
            }

            strong {
              font-size: 20px;
              color: #333;
              display: block;
              margin-top: 4px;
              margin-left: 24px;
            }
          }
          :nth-last-of-type(1) {
            margin-right: 0;
          }
        }
        .service-data {
          display: flex;
          flex-direction: row;
          position: relative;
          padding-top: 64px;
          .h3-options {
            position: absolute;
            top: 0;
            right: 0;
            height: 64px;
          }
          .service-chart {
            flex: 7;
            position: relative;
            height: 240px;
            .service-text {
              position: absolute;
              right: 32px;
              top: 0;
            }
            .tips {
              position: absolute;
              left: 0;
              width: 100%;
              text-align: center;
              top: 222px;
              font-size: 12px;
              color: #999;
            }
          }
          .service-chart-empty {
            background-image: url(https://ins-pro-luban.miao.cn/online/source/image/cf606ec0-07d7-11ed-83ed-6fdc185632f2.png);
            background-position: center;
            background-repeat: no-repeat;
            background-size: 240px 148px;
          }
          .service-top5 {
            position: relative;
            flex: 3;
            .h4-title {
              margin-top: 0;
            }
            .service-text {
              position: absolute;
              right: 0;
              top: 0;
              line-height: 14px;
            }
            .top5-list {
              padding-top: 8px;
              counter-reset: main;
              li {
                min-height: 34px;
                position: relative;
                padding-left: 22px;
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 33px;
                color: #333333;
                &::before {
                  font-family: "DIN";
                  list-style: none;
                  counter-increment: main;
                  content: counter(main);
                  text-align: center;
                  display: block;
                  position: absolute;
                  width: 14px;
                  height: 33px;
                  left: 0;
                  top: 0;
                  line-height: 33px;
                  font-weight: 500;
                  font-size: 14px;
                  background-size: contain;
                  background-position: center center;
                  background-repeat: no-repeat;
                }
                &:nth-of-type(1)::before {
                  content: "";
                  background-image: url(../../assets/images/11.png);
                }
                &:nth-of-type(2)::before {
                  content: "";
                  background-image: url(../../assets/images/22.png);
                }
                &:nth-of-type(3)::before {
                  content: "";
                  background-image: url(../../assets/images/33.png);
                }
                .num {
                  font-family: "DIN";
                  float: right;
                  font-style: normal;
                  font-weight: 500;
                  font-size: 14px;
                  color: #333333;
                }
              }
            }
          }
        }
      }
    }
    .top-right {
      margin-left: 16px;
      margin-bottom: 16px;
      display: flex;
      border-radius: 2px;
      flex-direction: column;
      .mb16 {
        margin-bottom: 16px;
      }
      .white-box {
        padding: 0 14px 14px;
        background-color: #fff;
        &-f1 {
          flex: 1;
        }
        .message-box {
          margin-top: 16px;
          width: 360px;
          background: #67C23A;
          border-radius: 4px;
          box-sizing: border-box;
          padding: 20px;
          background-image: url("./../../assets/images/you.png");
          background-position: right bottom;
          background-repeat: no-repeat;

          h1 {
            width: 100%;
            font-size: 24px;
            color: #fff;
            span {
              border-radius: 2px;
              background-color: #fff;
              height: 24px;
              line-height: 24px;
              text-align: center;
              color: #2051f5;
              font-size: 12px;
              padding: 3px 8px;
              vertical-align: middle;
            }
          }
          .co-name {
            font-size: 18px;
            margin-top: 16px;
            color: #fff;
          }
          .login-time {
            margin-top: 36px;
            font-size: 12px;
            color: #fff;
            opacity: 0.6;
          }
        }
        .agency-box {
          height: 100%;
          &-empty {
            background-image: url(https://ins-pro-luban.miao.cn/online/source/image/32e7bb20-0bbf-11ed-83ed-6fdc185632f2.png);
            background-position: center center;
            background-size: 98px 169px;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }
  .health-box {
    background-color: #fff;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 7px 24px 24px;
    .h3-options {
      .options-checkbox {
        margin-right: 50px;
        display: flex;
        .options-checkbox-data {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 26px;
          font-weight: 400;
          font-size: 14px;
          line-height: 14px;
          &::after {
            content: "";
            display: block;
            width: 10px;
            height: 10px;
            margin-left: 8px;
            background-image: url(https://ins-pro-luban.miao.cn/online/source/image/84c2ac90-0285-11ed-83ed-6fdc185632f2.png);
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
          }
        }
        .checked::after {
          background-image: url(https://ins-pro-luban.miao.cn/online/source/image/8d208ce0-0285-11ed-83ed-6fdc185632f2.png);
        }
      }
    }
    .health-data {
      display: flex;
      justify-content: center;
      height: 207px;
      .service-chart-empty {
        background-image: url(https://ins-pro-luban.miao.cn/online/source/image/cf606ec0-07d7-11ed-83ed-6fdc185632f2.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 240px 148px;
      }
      .health-chart {
        flex: 2;
        height: 207px;

        .service-text {
          float: right;
          margin-right: 45px;
        }
      }
      .top5 {
        margin-left: 45px;
        width: 336px;
        box-sizing: border-box;
        .h4-title {
          margin-top: 0;
        }
        .service-text {
          float: right;
        }
        .top5-list {
          padding-top: 8px;
          counter-reset: main;
          li {
            min-height: 34px;
            position: relative;
            padding-left: 22px;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 33px;
            color: #333333;
            border-bottom: 1px dotted #f7f7f7;
            &::before {
              font-family: "DIN";
              list-style: none;
              counter-increment: main;
              content: counter(main);
              text-align: center;
              display: block;
              position: absolute;
              width: 14px;
              height: 33px;
              left: 0;
              top: 0;
              line-height: 33px;
              font-weight: 500;
              font-size: 14px;
              background-size: contain;
              background-position: center center;
              background-repeat: no-repeat;
            }
            &:nth-of-type(1)::before {
              content: "";
              background-image: url(../../assets/images/11.png);
            }
            &:nth-of-type(2)::before {
              content: "";
              background-image: url(../../assets/images/22.png);
            }
            &:nth-of-type(3)::before {
              content: "";
              background-image: url(../../assets/images/33.png);
            }
            .num {
              font-family: "DIN";
              float: right;
              font-style: normal;
              font-weight: 500;
              font-size: 14px;
              color: #333333;
            }
          }
        }
      }
      .health-line {
        width: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        &::before {
          content: "";
          display: block;
          height: 140px;
          width: 4px;
          background: rgba(0, 0, 0, 0.05);
        }
      }
    }
  }
  .res-box {
    width: 100%;
    background-color: #fff;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 7px 24px 24px;
    .res-data {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .res-user {
        flex: 1;
        height: 240px;
        &:nth-of-type(3) {
          padding-left: 70px;
        }
        .service-text {
          float: right;
          padding-right: 82px;
        }
      }
      .real-line {
        width: 4px;
        height: 140px;
        background-color: #0000000d;
      }
    }
  }
}
</style>
